module.exports = __webpack_public_path__ + "static/media/A1-26-Upgrade-das-Naves-cod124.3bd21f8c.png";